"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'profession.list.title': 'Zawody',
    'profession.list.empty': 'Nie znaleziono zawodów',
};
